/**
 * @fileoverview Module for `src/lib/functions/isNonEmptyString.js`.
 */

/**
 * Checks whether a value is a string with at least one non-whitespace character.
 *
 * @param {*} value - Value to check.
 * @returns {boolean} True when the value is a nonblank string.
 */
function isNonEmptyString(value) {
  return typeof value === 'string' && value.trim() !== '';
}

export default isNonEmptyString;
